import type { CreateCryptoAddressFormValues } from '@/features/create-crypto-address';
import { CreateSavedAddressModal } from '../ui';
import { useModalStore } from '@/shared/lib';
import type { CreateSavedAddressModalTab } from './types';
import type { CreateCardFormValues } from '@/features/create-card';
import type { BankAddressStepResponse } from '@/entities/bank-address';

type Params = {
  onBack: () => void;
  onClose?: () => void;
  onCreateSuccess?: () => void;
  showOnlyTab?: CreateSavedAddressModalTab;
  initialCryptoFormValues?: Partial<CreateCryptoAddressFormValues>;
  initialCardFormValues?: Partial<CreateCardFormValues>;
  initialBankFormFields?: BankAddressStepResponse;
};

export function useCreateSavedAddressModal() {
  const { showDialogComponent, closeDialog, cleanup } = useModalStore();

  const onCloseDialog = () => {
    cleanup();
    closeDialog();
  };

  const openCreateSavedAddressModal = ({
    onBack,
    onClose,
    onCreateSuccess,
    showOnlyTab,
    initialCryptoFormValues,
    initialCardFormValues,
    initialBankFormFields,
  }: Params) => {
    showDialogComponent({
      component: (
        <CreateSavedAddressModal
          onBack={() => {
            onCloseDialog();
            onBack();
          }}
          onCreateSuccess={() => {
            onCloseDialog();
            if (onCreateSuccess) {
              onCreateSuccess();
              return;
            }
            onBack();
          }}
          showOnlyTab={showOnlyTab}
          initialCryptoFormValues={initialCryptoFormValues}
          initialCardFormValues={initialCardFormValues}
          initialBankFormFields={initialBankFormFields}
        />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-hidden border-0 flex',
      onClose: () => {
        if (onClose) {
          onClose();
        }
        onCloseDialog();
      },
    });
  };

  return { openCreateSavedAddressModal };
}
